import React from "react";
import { Modal, Button } from "react-bootstrap";
function Int7(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Member of DORA
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modalparas">
        <div className="modal-body recog">
          <p>
            <span id="theun">
              ISBM University is proud to be a signatory of the Declaration on
              Research Assessment (DORA).
            </span>{" "}
            DORA is a global initiative that emphasizes the importance of
            advancing research evaluation practices by encouraging the
            responsible use of metrics and providing strategic recommendations
            for more effective and equitable assessment. At ISBM University,
            reforming research assessment is a key priority, enabling us to
            cultivate and sustain a vibrant research culture. Through this
            approach, we ensure our researchers are well-supported in achieving
            their full potential, while strengthening both the quality and
            impact of our research.
          </p>

          <p>
            In alignment with our commitments to DORA, ISBM University will
            establish a Research Assessment Reform Working Group. This group
            will be responsible for formulating and implementing a statement on
            responsible research assessment, as well as developing a
            comprehensive action plan to drive the reform of research evaluation
            across the University.
          </p>
          <p id="wearesd">
            ISBM University is committed to embedding the principles of DORA
            across all its activities. For any enquiries regarding DORA or our
            research assessment reform initiatives, please contact  <strong>Dr. Trilok</strong>.
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default Int7;
